import "core-js/modules/es6.object.define-property";

var _$20$30$40$50$60$;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (_$20$30$40$50$60$ = {}, _defineProperty(_$20$30$40$50$60$, 10, '#e1faeb'), _defineProperty(_$20$30$40$50$60$, 20, '#abedc5'), _defineProperty(_$20$30$40$50$60$, 30, '#7ddba3'), _defineProperty(_$20$30$40$50$60$, 40, '#57c282'), _defineProperty(_$20$30$40$50$60$, 50, '#3ba164'), _defineProperty(_$20$30$40$50$60$, 60, '#2a854e'), _defineProperty(_$20$30$40$50$60$, 70, '#20693d'), _defineProperty(_$20$30$40$50$60$, 80, '#1a5230'), _defineProperty(_$20$30$40$50$60$, 90, '#153d25'), _defineProperty(_$20$30$40$50$60$, 100, '#112b1b'), _$20$30$40$50$60$);